module.exports = __webpack_public_path__ + "img/Phone.0e6cfea0.svg";